






import { Component, Vue } from "vue-property-decorator";
import { UserModule } from "@/store/modules/user";

@Component({
  name: "App",
  created() {
    // // 在页面加载时读取sessionStorage里的状态信息
    // const session = sessionStorage.getItem("Evi_Platform_Store");
    // if (typeof session.name !== "undefined") {
    //   const userInfo = JSON.parse(
    //     sessionStorage.getItem("Evi_Platform_Store") as string
    //   );
    //   UserModule.SetUser(userInfo);
    //   console.log(userInfo);
    //   console.log("111111");
    //   sessionStorage.removeItem("Evi_Platform_Store");
    // }
    // 在页面刷新时将vuex里的信息保存到sessionStorage里
    window.addEventListener("beforeunload", () => {
      console.log("页面被刷新");
      const state = JSON.stringify(UserModule.userInfo);
      sessionStorage.setItem("Evi_Platform_Store", state == null ? "" : state);
    });
  }
})
export default class extends Vue {}
